import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 查询计提数据
 * @param data
 * @returns {*}
 */
export function advancedQueryProvisionFunc(data) {
  return request({
    url: URL.booking.provisionReport.advancedQueryUrl,
    method: 'post',
    data
  })
}

/**
 * 查询规则
 * @param data
 * @returns {*}
 */
export function advancedQueryFunc(data) {
  return request({
    url: URL.booking.provisionReport.queryHistoryUrl,
    method: 'post',
    data
  })
}

/**
 * 确认计提
 * @param data
 * @returns {*}
 */
export function confirmProvisionFunc(data) {
  return request({
    url: URL.booking.provisionReport.confirmProvisionUrl,
    method: 'post',
    data
  })
}

/**
 * 试运行
 * @param data
 * @returns {*}
 */
export function testRunFunc(data) {
  return request({
    url: URL.booking.provisionReport.testRunUrl,
    method: 'post',
    data
  })
}

/**
 * 检查今日是否已经计提
 * @param data
 * @returns {*}
 */
export function checkAccrueFunc(data) {
  return request({
    url: URL.booking.provisionReport.checkAccrueUrl,
    method: 'post',
    data
  })
}

/**
 * 查看关联业务
 * @param data
 * @returns {*}
 */
export function queryJobDataByUuidsFunc(data) {
  return request({
    url: URL.booking.provisionReport.queryJobDataByUuidsUrl,
    method: 'post',
    data
  })
}

/**
 * 取消计提
 * @param data
 * @returns {*}
 */
export function cancelProvisionFunc(data) {
  return request({
    url: URL.booking.provisionReport.cancelProvisionUrl,
    method: 'post',
    data
  })
}
